var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHired(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#F7F8FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4992 48.5C56.4693 48.5 61.309 43.37 61.309 37.0417C61.309 30.7134 56.4693 25.5834 50.4992 25.5834C44.5291 25.5834 39.6895 30.7134 39.6895 37.0417C39.6895 43.37 44.5291 48.5 50.4992 48.5Z",
    stroke: "#4540DB",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3094 71.4167H35.9411C35.3279 71.4169 34.7217 71.2788 34.1627 71.0116C33.6038 70.7444 33.1048 70.3543 32.6989 69.8671C32.2931 69.3799 31.9896 68.8067 31.8087 68.1857C31.6278 67.5647 31.5735 66.91 31.6496 66.265L32.4927 59.1059C32.6888 57.4426 33.4514 55.9126 34.637 54.8035C35.8227 53.6945 37.3497 53.0827 38.931 53.0834H39.6899",
    stroke: "#4540DB",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1475 57.6667L64.0118 62.25L72.1192 53.0834",
    stroke: "#4540DB",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHired);
export default __webpack_public_path__ + "static/media/Hired.5acf86b321ee508a2b53d3cf2d4eea4e.svg";
export { ForwardRef as ReactComponent };